import { AfterContentChecked, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DadosUsuario } from 'src/app/precos-combustiveis/model/AlteracaoCombustivel';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import {
  IMacroPostoResponse,
  IPostoMacroPosto,
  MacroPostoServicesService,
} from '../../services/macro-posto-services.service';
import {
  IErroPrecoCombustivel,
  INomeCombustivel,
  IPayloadAtualizarPrecos,
  IPrecoPosto,
} from '../central.interface';
import { CentralService } from '../central.service';

@Component({
  selector: 'app-tela-principal',
  templateUrl: './tela-principal.component.html',
  styleUrls: ['./tela-principal.component.scss'],
})
export class TelaPrincipalComponent implements AfterContentChecked {
  private service = inject(CentralService);
  private snack = inject(SnackBarService);
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  private macroPostoService = inject(MacroPostoServicesService);

  private dadosUsuario: DadosUsuario = {} as DadosUsuario;
  private copiaOriginal: IPrecoPosto[] = [];

  public algumCombustivelDesatualizado: boolean = false;
  public mostrarModal: boolean = false;
  public confirmarPrecosModal: boolean = false;
  public comfirmaZerarCombustivel: boolean = false;
  public comfirmaMudancaPosto: boolean = false;
  public mostrarPrimeiraAba: boolean = true;
  public loading: boolean = true;
  public eHRedeEspecial: boolean = true;
  public usuarioTemAcessoUploadCsv: boolean = false;
  public msgModalLoading: string = 'Aguarde, buscando preços...';
  public msgInicialTabelaPrecos: string = 'Nenhum dado encontrado!';

  public usuarioMacroPosto: boolean = false;
  public postosMacroPosto?: IPostoMacroPosto[];
  public postoSelecionado?: IPostoMacroPosto;
  public precosPosto: IPrecoPosto[] = [];
  public demaisPrecos: IPrecoPosto[] = [];
  public precoSendoModificado!: IPrecoPosto;

  public combustiveisModificados: INomeCombustivel[] = [];
  @Input() ehRedeEspecial: boolean = false;

  constructor() {
    this.getDadosUsuario();
  }

  ngAfterContentChecked() {
    this.sendHeight();
  }
  private sendHeight() {
    var height = document.documentElement.scrollHeight;
    window.parent.postMessage({ iframeHeight: height }, '*');
  }

  private getAcessoUploadCvs() {
    this.service
      .verificarAcessoUploadCsv(this.dadosUsuario.guid)
      .subscribe((result: boolean) => {
        this.usuarioTemAcessoUploadCsv = result;
      });
  }

  private getListaPrecosPosto() {
    try {
      this.service
        .getListaPrecosPosto(this.dadosUsuario.codPosto, this.dadosUsuario.guid)
        .subscribe((data: IPrecoPosto[]) => {
          console.log('Precos:', data);

          this.copiaOriginal = JSON.parse(JSON.stringify(data));
          this.ehRedeEspecial = data.some((p) => p.ehRedeEspecial);
          const precosComValores = data.filter((preco) => preco.precoBomba > 0);
          const precosSemValores = data.filter(
            (preco) => preco.precoBomba === 0,
          );

          const todosPrecosZerados = data.every(
            (preco) =>
              preco.precoBomba === 0 &&
              preco.descontoSps === 0 &&
              preco.descontoRedeEspecial === 0,
          );
          this.mostrarPrimeiraAba = !todosPrecosZerados;

          this.precosPosto = todosPrecosZerados ? [] : precosComValores;
          this.demaisPrecos = todosPrecosZerados ? data : precosSemValores;

          this.algumCombustivelDesatualizado = this.precosPosto.some(
            (x) => x.desatualizado,
          );
          this.loading = false;
        });
    } catch (error) {
      console.log('Erro ao buscar preços:', error);
      this.snack.flashMessage(
        'Erro ao buscar preços!',
        ['snackbar-error'],
        'Fechar',
        2,
      );
      this.loading = false;
    }
  }

  private getDadosUsuariosMacroPosto() {
    this.msgInicialTabelaPrecos =
      'Selecione um posto e clique em buscar preços.';
    this.macroPostoService
      .listarPostosMacroPostoAsync()
      .subscribe((res: IMacroPostoResponse) => {
        let ordenados = res.retorno.sort((a, b) => a.codPosto - b.codPosto);
        this.postosMacroPosto = ordenados;
        this.postosMacroPosto = res.retorno;
        this.usuarioMacroPosto = true;
        this.loading = false;
      });
  }

  private async getDadosUsuariosPosto() {
    //await this.verificarRedirecionamentoTelaAntiga();

    this.getListaPrecosPosto();
  }

  private async getDadosUsuario() {
    try {
      var userData = this.localStorageService.getItem('userData');
      let u = JSON.parse(userData);

      let d: DadosUsuario = {
        guid: u.retorno.guid,
        codPosto: u.retorno.codigoEntidade,
        dscemail: u.retorno.email,
        dsctelefone: u.retorno.celular,
        dsclogin: u.retorno.login,
        tipo: u.retorno.tipo,
      };
      this.dadosUsuario = d;

      if (userData !== null || u.guid !== null) {
        this.dadosUsuario = d;
        this.getAcessoUploadCvs();

        if (this.macroPostoService.usuarioEhMacroPosto()) {
          this.getDadosUsuariosMacroPosto();
          // this.usuarioMacroPosto;
          //this.getDadosUsuariosMacroPosto();
        } else {
          this.getDadosUsuariosPosto();
        }

        //   await this.verificarRedirecionamentoTelaAntiga();
        //   this.getAcessoUploadCvs();
        //   this.getListaPrecosPosto();
        // } else {
        //   this.snack.flashMessage(
        //     'Erro nos dados de consulta do usuário!',
        //     ['snackbar-error'],
        //     'Fechar',
        //     2
        //   );
      }
    } catch (error) {
      this.snack.flashMessage(
        'Erro ao buscar preços!',
        ['snackbar-error'],
        'Fechar',
        2,
      );
      this.loading = false;
    }
  }

  // private async verificarRedirecionamentoTelaAntiga() {
  //   try {
  //     const result = await this.service.verificarRedirecionamentoTelaAntiga(
  //       this.dadosUsuario.guid,
  //     );

  //     console.log('Resultado redirecionamento:', result);
  //     // se true redireciona precos antigo
  //     if (result) {
  //       console.log(result);
  //       this.router.navigateByUrl('tela-preco-combustivel').then((r: any) => {
  //         console.log(r);
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  private removerErrosCombustivel(preco: IPrecoPosto, tipoErro: string) {
    preco.possuiErros = false;
    preco.erros = preco.erros.filter((x) => x.tipoErro != tipoErro);
  }

  private alterandoPrecoBomba(item: IPrecoPosto) {
    item.precoRedeEspecial = item.precoBomba - item.descontoRedeEspecial;
    item.precoSps = item.precoBomba - item.descontoSps;
    item.erros = [];
  }

  private alterandoDescontoSps(item: IPrecoPosto) {
    this.removerErrosCombustivel(item, 'Sps > Bomba');
    this.removerErrosCombustivel(item, 'Sps > Rede');

    if (item.descontoSps > item.precoBomba) {
      let err: IErroPrecoCombustivel = {
        msg: `Desconto SPS no ${item.descricaoCombustivel} não pode ser maior que o preço bomba`,
        tipoErro: 'Sps > Bomba',
      };
      item.erros.push(err);
    }

    if (item.descontoSps > item.descontoRedeEspecial && this.ehRedeEspecial) {
      let err: IErroPrecoCombustivel = {
        msg: `Desconto SPS no ${item.descricaoCombustivel} não pode ser maior que o desconto Rede Especial`,
        tipoErro: 'Sps > Rede',
      };
      item.erros.push(err);
    }
  }

  private aletrarndoDescontoReedeEspecial(item: IPrecoPosto) {
    this.removerErrosCombustivel(item, 'Rede < Sps');
    this.removerErrosCombustivel(item, 'Rede > Bomba');

    if (item.descontoRedeEspecial < item.descontoSps && this.ehRedeEspecial) {
      let err: IErroPrecoCombustivel = {
        msg: `Desconto Rede Especial no ${item.descricaoCombustivel} não pode ser menor que o desconto SPS`,
        tipoErro: 'Rede < Sps',
      };
      item.erros.push(err);
    }

    if (item.descontoRedeEspecial > item.precoBomba) {
      let err: IErroPrecoCombustivel = {
        msg: `Desconto Rede Especial no ${item.descricaoCombustivel} não pode ser maior que o preço bomba`,
        tipoErro: 'Rede > Bomba',
      };
      item.erros.push(err);
    }
  }

  verificarPrecosNull(preco: IPrecoPosto) {
    if (preco.precoBomba == null) {
      preco.precoBomba = 0;
    }

    if (preco.descontoSps == null) {
      preco.descontoSps = 0;
    }

    if (preco.descontoRedeEspecial == null) {
      preco.descontoRedeEspecial = 0;
    }
  }

  verificarPrecos(preco: IPrecoPosto) {
    this.alterandoPrecoBomba(preco);
    this.alterandoDescontoSps(preco);
    if (this.ehRedeEspecial) this.aletrarndoDescontoReedeEspecial(preco);
    this.verificarAlteracao(preco);
    this.verificarPrecosNull(preco);

    preco.possuiErros = preco.erros.length > 0;
  }

  private verificarAlteracao(preco: IPrecoPosto) {
    this.combustiveisModificados = this.combustiveisModificados.filter(
      (x) => x.codCombustivel != preco.codCombustivel,
    );

    var precoOriginal = this.copiaOriginal.find(
      (x) => x.codCombustivel == preco.codCombustivel,
    );

    if (precoOriginal) {
      if (
        precoOriginal.precoBomba != preco.precoBomba ||
        precoOriginal.descontoSps != preco.descontoSps ||
        precoOriginal.descontoRedeEspecial != preco.descontoRedeEspecial
      ) {
        this.combustiveisModificados.push({
          codCombustivel: preco.codCombustivel,
          descricaoCombustivel: preco.descricaoCombustivel,
        });
      }
    }
  }

  private converterPayload(
    preco: IPrecoPosto,
  ): Observable<IPayloadAtualizarPrecos> {
    const disponiverParaVenda = preco.precoBomba > 0 ? 1 : 0;

    let a: IPayloadAtualizarPrecos = {
      guid: this.dadosUsuario.guid.trim(),
      codPosto: this.dadosUsuario.codPosto,
      dsclogin: this.dadosUsuario.dsclogin?.trim(),
      dscemail: this.dadosUsuario.dscemail?.trim(),
      dsctelefone: this.dadosUsuario.dsctelefone?.trim(),
      tipo: this.dadosUsuario.tipo,
      combustivel: {
        indCombustivel: preco.codCombustivel,
        descricaoCombustivel: preco.descricaoCombustivel,
        precoNovo: {
          descricao: 'Preço de bomba',
          valor: preco.precoBomba,
        },
        descontoCentavos: {
          descricao: 'Desconto em Reais',
          valor: preco.descontoSps,
        },
        descontoPercentual: {
          descricao: 'Desconto porcentual',
          valor: parseFloat(
            (
              ((preco.precoBomba - preco.precoSps) / preco.precoBomba) *
              100
            ).toFixed(2),
          ),
        },
        precoNegociado: {
          descricao: 'Preço para UVE / SPS. Sujeito a aprovação.',
          valor: parseFloat((preco.precoBomba - preco.descontoSps).toFixed(2)),
        },
        precoRedeEspecial: {
          descricao: preco.descricaoRedeEspecial,
          valor: parseFloat(preco.descontoRedeEspecial.toFixed(2)),
        },
        precoPrazo: {
          descricao: 'Preço a prazo',
          valor: preco.precoBomba,
        },
        precoUnitario: {
          descricao: 'Preço de bomba',
          valor: preco.precoBomba,
        },
        precoAnterior: {
          descricao: 'Preço de bomba',
          valor: preco.precoAnterior,
        },
        disponivelParaVenda: disponiverParaVenda,
      },
    };

    if (!this.ehRedeEspecial) {
      a.combustivel.precoRedeEspecial = null;
    }
    return of(a);
  }

  async manterPrecos() {
    this.msgModalLoading = 'Aguarde, confirmando preços...';
    this.loading = true;
    this.confirmarPrecosModal = false;
    let sucesso = true;

    try {
      for (var preco of this.precosPosto) {
        preco.erros = [];

        const payload = await new Promise((resolve, reject) => {
          this.converterPayload(preco).subscribe(
            (result) => resolve(result),
            (error) => reject(error),
          );
        });

        const result = await this.service.enviarPrecosPosto(
          JSON.stringify(JSON.stringify(payload)),
        );

        if (result.COD_RETORNO == 0) {
          preco.dataUltimaAtualizacao = new Date();
          preco.precoAnterior = preco.precoBomba;
          preco.possuiErros = false;
          preco.desatualizado = false;
        } else {
          preco.possuiErros = true;
          let err: IErroPrecoCombustivel = {
            msg: result.DSC_RETORNO,
            tipoErro: 'Retorno',
          };
          preco.erros.push(err);
          sucesso = false;
        }
      }
      this.algumCombustivelDesatualizado = this.precosPosto.some(
        (x) => x.desatualizado,
      );
    } catch (error) {
      console.log('Erro ao processar preço:', error);
      this.snack.flashMessage(
        'Erro ao processar preço!',
        ['snackbar-error'],
        'Fechar',
        2,
      );
    } finally {
      this.loading = false;
    }
  }

  private async processarPrecos(precos: IPrecoPosto[]) {
    let sucessos = [];
    // Processa cada preço sequencialmente
    for (const preco of precos) {
      preco.erros = [];
      preco.possuiErros = false;

      try {
        // Converte o payload (usando await para esperar a conclusão)
        const payload = await new Promise((resolve, reject) => {
          this.converterPayload(preco).subscribe(
            (result) => resolve(result),
            (error) => reject(error),
          );
        });

        // Envia o preço e espera a resposta
        const result = await this.service.enviarPrecosPosto(
          JSON.stringify(JSON.stringify(payload)),
        );

        console.log('Resultado:', result);
        // Processa o resultado
        if (result.COD_RETORNO == 0) {
          preco.dataUltimaAtualizacao = new Date();
          preco.precoAnterior = preco.precoBomba;
          sucessos.push(true);
        } else {
          preco.possuiErros = true;
          let err: IErroPrecoCombustivel = {
            msg: result.DSC_RETORNO,
            tipoErro: 'Retorno',
          };
          preco.erros.push(err);
          sucessos.push(false);
        }
      } catch (error) {
        sucessos.push(false);
      }
    }

    if (sucessos.every((s) => s)) {
      this.snack.flashMessage(
        'Preços atualizados com sucesso!',
        ['snackbar-info'],
        'Fechar',
        2,
      );
      await this.getListaPrecosPosto();
      await this.manterPrecos();
    } else {
      this.snack.flashMessage(
        'Erro ao atualizar algum dos preços!',
        ['snackbar-error'],
        'Fechar',
        2,
      );
    }

    sucessos = [];
  }

  existeErro() {
    const precosComErros = this.precosPosto.some((preco) => preco.possuiErros);
    const demaisPrecosComErros = this.demaisPrecos.some(
      (preco) => preco.possuiErros,
    );
    return precosComErros || demaisPrecosComErros;
  }

  async submeterPrecos() {
    var combustiveisAlterados = this.combustiveisModificados.map(
      (x) => x.codCombustivel,
    );

    let todosCombustiveis = this.precosPosto.concat(this.demaisPrecos);
    let combustiveisAlteradosTodos = todosCombustiveis.filter((x) =>
      combustiveisAlterados.includes(x.codCombustivel),
    );

    var precosAlterados = combustiveisAlteradosTodos.filter((x) =>
      combustiveisAlterados.includes(x.codCombustivel),
    );

    this.processarPrecos(precosAlterados);

    this.mostrarModal = false;
    this.combustiveisModificados = [];
  }

  handleZerarPrecoCombustivel(preco: IPrecoPosto) {
    this.comfirmaZerarCombustivel = !this.comfirmaZerarCombustivel;
    this.precoSendoModificado = preco;
  }

  private removerPrecoComValor() {
    this.precosPosto = this.precosPosto.filter(
      (item) =>
        item.codCombustivel !== this.precoSendoModificado.codCombustivel,
    );
    this.demaisPrecos.push(this.precoSendoModificado);
  }

  async zerarPrecoCombustivel() {
    console.log(this.precoSendoModificado);
    this.precoSendoModificado.precoBomba = 0;
    this.precoSendoModificado.descontoRedeEspecial = 0;
    this.precoSendoModificado.descontoSps = 0;
    this.precoSendoModificado.precoRedeEspecial = 0;
    this.precoSendoModificado.precoSps = 0;
    this.precoSendoModificado.dispovivelParaVenda = false;

    const payload = await new Promise((resolve, reject) => {
      this.converterPayload(this.precoSendoModificado).subscribe(
        (result) => resolve(result),
        (error) => reject(error),
      );
    });

    this.service
      .enviarPrecosPosto(JSON.stringify(JSON.stringify(payload)))
      .then((res) => {
        this.removerPrecoComValor();
        this.snack.flashMessage(
          `Combustivel ${this.precoSendoModificado.descricaoCombustivel} zerado com sucesso!`,
          ['snackbar-info'],
          'Fechar',
          2,
        );
      })
      .catch((err) => {
        console.log(err);
        this.snack.flashMessage(
          `Erro ao zerar ${this.precoSendoModificado.descricaoCombustivel}, tente novamante por favor!`,
          ['snackbar-error'],
          'Fechar',
          2,
        );
      })
      .finally(() => {
        this.comfirmaZerarCombustivel = !this.comfirmaZerarCombustivel;
      });
  }

  baixarPdf(nomeArquivo: string) {
    const link = document.createElement('a');
    link.href = `assets/arquivos/${nomeArquivo}`;
    link.download = nomeArquivo;
    link.click();
  }

  private houveMudancasNosPrecos(): boolean {
    return this.combustiveisModificados.length > 0;
  }

  handlePostoSelecionado($event: IPostoMacroPosto) {
    this.msgModalLoading = 'Aguarde, buscando preços...';
    this.dadosUsuario.codPosto = $event.codPosto;
    this.postoSelecionado = $event;
    console.log('Posto selecionado:', $event);
    if (this.houveMudancasNosPrecos()) {
      this.comfirmaMudancaPosto = true;
      ('');
    } else {
      this.loading = true;
      this.getListaPrecosPosto();
    }
  }

  confirmarTroca() {
    this.getListaPrecosPosto();
    this.comfirmaMudancaPosto = false;
  }

  cancelarTroca() {
    this.comfirmaMudancaPosto = false;
  }
}
